<template>
  <div id="hub-popup-wrapper" class="hub-popup-wrapper">
    <transition name="collapse-popup">
      <div id="hub-popup" class="hub-popup" v-show="isMouseHoverHub">
        <div id="hub-popup-content" class="hub-popup-content">
          <div class="md-body-2">{{ getMainMessage }}</div>
          <div class="md-caption">{{ getDetailsMessage }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HubPopup',
  computed: {
    ...mapState('map', [
      'isMouseHoverHub',
      'hoveredStep'
    ]),
    getMainMessage () {
      return !this.hoveredStep ? null : this.hoveredStep.position === 'CURRENT' ? this.$t('MAP.LABEL.PACKAGE_LOCATION')
        : this.hoveredStep.position === 'FUTURE' ? this.$t('MAP.LABEL.PACKAGE_NEXT_LOCATION') : this.$t('MAP.LABEL.PACKAGE_LAST_LOCATION')
    },
    getDetailsMessage () {
      return this.isMouseHoverHub ? this.$t('MAP.LABEL.CLICK_FOR_DETAILS') : null
    }
  }
}
</script>

<style lang="sass" scoped>
.hub-popup-wrapper
  position: absolute
  left: -50px
  min-width: 280px
  bottom: 30px
.hub-popup
  max-height: 500px
  height: 75px
  background-color: white
  -webkit-filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2))
  filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2))
  padding: 15px
  border-radius: 10px
  border: 1px solid #cccccc
.hub-popup:after, .hub-popup:before
  top: 100%
  border: solid transparent
  content: " "
  height: 0
  width: 0
  position: absolute
  pointer-events: none
.hub-popup:after
  border-top-color: white
  border-width: 10px
  left: 48px
  margin-left: -10px
.hub-popup:before
  border-top-color: #cccccc
  border-width: 11px
  left: 48px
  margin-left: -11px

.collapse-popup-enter-active, .collapse-popup-leave-active
  transition: opacity .6s
.collapse-popup-enter, .collapse-popup-leave-to
  opacity: 0
</style>
